export default __webpack_public_path__ + "static/media/experience-doctor.c7527ae3.jpg";